const x = {
  s: "2px",
  m: "4px",
  l: "8px",
  xl: "12px",
  full: "50%"
};
export {
  x as borderRadius
};
//# sourceMappingURL=borderRadius.es.js.map
